import { usePageContentNoProxy } from "@RHCommerceDev/custom-providers/LocationProvider";
import { emailAtom, isCreateAccount } from "@RHCommerceDev/hooks-atoms";
import { Typography } from "@RHCommerceDev/unstyled-ui-components/Typography";
import { useStytch } from "@stytch/react";
import { useCreateAccountTemplate } from "@RHCommerceDev/hooks/useCreateAccountTemplate";
import { useAtomValue } from "jotai";
import template from "lodash.template";
import * as React from "react";
import { useCallback } from "react";
import { getGlobal } from "utils/Globals/getGlobal";
import memoize from "utils/memoize";
import { processEnvServer } from "@RHCommerceDev/hooks/useSsrHooks";
import { getClientOrigin } from "@RHCommerceDev/utils/getClientOrigin";

const CheckYourInbox = () => {
  const { pageContent } = usePageContentNoProxy();
  const stytchData = pageContent?.emailSignupContent;
  const email = useAtomValue(emailAtom);
  const messageTemplate = stytchData?.An_Email_has || "";
  const compiled = template(messageTemplate);
  const isCreate = useAtomValue(isCreateAccount);
  const stytchClient = useStytch();
  const env = getGlobal("_env");
  const templateId = useCreateAccountTemplate();

  const message = compiled({
    email: `<strong class="font-bold">${email}</strong>`
  });

  const hostName = processEnvServer
    ? getClientOrigin()
    : window?.location?.origin;

  const handleResendEmail = useCallback(() => {
    try {
      stytchClient.magicLinks.email.send(email, {
        login_magic_link_url: `${hostName}`,
        login_expiration_minutes: 60,
        login_template_id: templateId
      });
    } catch (error) {
      console.log(error);
    }
  }, [hostName]);

  return (
    <div
      className={` ${
        isCreate ? "h-[348px]" : "h-60"
      } flex flex-col items-center justify-center`}
    >
      <Typography className=" text-transform: h-6  w-full  font-primary-rh-thin text-xl uppercase leading-6">
        {stytchData?.PLEASE_CHECK_YOUR}
      </Typography>

      {isCreate ? (
        <div className="mt-4">
          <Typography className="font-300 h-7 text-center font-primary-rhlight text-xxsm leading-tight">
            {stytchData?.Please_verify_your}
            <br />
            {stytchData?.A_message_with}
          </Typography>

          <div className="mt-6 flex justify-center">
            <button
              className="decoration-0.5px p-0 !underline !underline-offset-[3px]"
              onClick={handleResendEmail}
            >
              <Typography className="decoration-0.5px font-primary-rhlight text-xxsm tracking-[0.44px] underline underline-offset-[3px]">
                {stytchData?.Resend_Verification_Email}{" "}
              </Typography>
            </button>
          </div>
        </div>
      ) : (
        <div className="mt-6">
          <Typography className="tracking-0.165px !block h-7 text-center font-primary-rhsans !font-light leading-[13.75px]">
            <span dangerouslySetInnerHTML={{ __html: message }} />
            {stytchData?.The_link_will}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default memoize(CheckYourInbox);
